export default __webpack_public_path__ + "static/media/cs_icon_02.e1a72de1.png";